var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _clipPath, _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgParseableinline = function SvgParseableinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "parseable_inline_svg__Layer_1",
    viewBox: "0 0 721.95 144.74"
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "parseable_inline_svg__linear-gradient",
    x1: 108.22,
    x2: 711.81,
    y1: 72.42,
    y2: 72.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc466b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a550ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f5efb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "parseable_inline_svg__linear-gradient-2",
    x1: 197.02,
    x2: 260.77,
    y1: 59.91,
    y2: 59.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc466b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ee4775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cb4c8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9253bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#445df6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f5efb"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-3",
    x1: 108.68,
    x2: 712.27,
    y1: 72.32,
    y2: 72.32
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-4",
    x1: 273.45,
    x2: 311.6,
    y1: 59.29,
    y2: 59.29
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-5",
    x1: 273.45,
    x2: 311.6,
    y1: 59.29,
    y2: 59.29
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-6",
    x1: 108.68,
    x2: 712.27,
    y1: 72.32,
    y2: 72.32
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-7",
    x1: 317.44,
    x2: 369.89
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-8",
    x1: 317.44,
    x2: 369.89
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-9",
    x1: 108.68,
    x2: 712.27,
    y1: 72.32,
    y2: 72.32
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-10",
    x1: 377.97,
    x2: 440.35
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-11",
    x1: 377.97,
    x2: 440.35
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-12",
    x1: 108.68,
    x2: 712.27,
    y1: 72.32,
    y2: 72.32
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-13",
    x1: 449.42,
    x2: 513.18
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-14",
    x1: 449.42,
    x2: 513.18
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-15",
    x1: 108.68,
    x2: 712.27,
    y1: 72.32,
    y2: 72.32
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-16",
    x1: 525.85,
    x2: 589.61,
    y1: 50.71,
    y2: 50.71
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-17",
    x1: 525.85,
    x2: 589.61,
    y1: 50.71,
    y2: 50.71
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "parseable_inline_svg__linear-gradient-18",
    x1: 108.68,
    x2: 712.27,
    y1: 72.32,
    y2: 72.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc466b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ee4775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cb4b8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9a52b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5b5ae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f5efb"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-19",
    x1: 600.42,
    x2: 617.07,
    y1: 50.09,
    y2: 50.09
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-20",
    x1: 600.42,
    x2: 617.07,
    y1: 50.09,
    y2: 50.09
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-21",
    x1: 108.68,
    x2: 712.27,
    y1: 72.32,
    y2: 72.32
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-22",
    x1: 635.71,
    x2: 698.09,
    y1: 61.82,
    y2: 61.82
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#parseable_inline_svg__linear-gradient-2",
    id: "parseable_inline_svg__linear-gradient-23",
    x1: 635.71,
    x2: 698.09,
    y1: 61.82,
    y2: 61.82
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "parseable_inline_svg__linear-gradient-24",
    x1: 118.36,
    x2: 721.95,
    y1: 72.37,
    y2: 72.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc466b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ee4775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cb4c8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9353ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#545beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f5efb"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "parseable_inline_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.32 28.84h15.78v7.46c5.1-6.09 12.43-8.7 19.88-8.7 17.15 0 28.09 14.42 28.09 32.19s-11.19 32.44-28.34 32.44c-7.21 0-14.29-2.86-18.77-8.33v24.98h-16.65V28.84Zm46.73 31.07c0-9.82-6.34-16.9-15.41-16.9-8.45 0-14.79 6.96-14.79 16.9s6.21 16.9 14.79 16.9c9.07 0 15.41-7.08 15.41-16.9Z",
    style: {
      fill: "none"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "parseable_inline_svg__clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.02 59.91c0-17.9 10.94-32.31 28.09-32.31 7.21 0 14.91 2.86 19.39 8.82v-7.58h16.28v62.14H244.5v-7.46c-4.35 5.97-12.18 8.7-19.39 8.7-17.15 0-28.09-14.42-28.09-32.31Zm47.1 0c0-9.7-6.21-16.9-14.79-16.9s-15.41 7.21-15.41 16.9 6.46 16.9 15.41 16.9 14.79-6.96 14.79-16.9Z",
    className: "parseable_inline_svg__cls-18"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "parseable_inline_svg__clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.45 28.84h16.4v11.93c1.74-5.09 8.08-13.17 21.75-13.17v18.15c-14.42 0-21.5 6.59-21.5 21.38v23.86h-16.65V28.84Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-5)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "parseable_inline_svg__clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m317.44 83.77 5.97-12.8c4.23 3.23 10.07 6.59 19.39 6.59 3.85 0 10.19-1.49 10.19-5.22s-5.34-4.6-10.69-6.09c-12.3-3.23-22.37-7.33-22.37-19.26 0-12.68 12.43-19.39 24.11-19.39 10.19 0 16.65 2.49 23.12 6.21l-5.59 12.43c-6.09-2.98-11.81-4.35-17.27-4.35-3.85 0-7.46 1.74-7.46 4.35 0 3.48 5.22 4.6 10.94 5.84 10.56 2.49 22.12 7.08 22.12 19.76 0 15.29-15.54 20.38-27.09 20.38-13.3 0-21.87-5.22-25.35-8.45Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-8)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "parseable_inline_svg__clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.97 59.91c0-17.9 13.92-32.31 32.19-32.31 16.9 0 30.2 14.42 30.2 32.06 0 2.98-.37 5.97-.37 5.97h-45.11c1.99 8.57 9.07 12.68 17.28 12.68 5.96 0 12.18-1.74 16.78-4.85l6.21 11.93c-6.96 4.6-15.04 6.83-23.11 6.83-18.15 0-34.05-11.81-34.05-32.31Zm46.73-5.34c-1.24-7.83-7.46-13.05-15.04-13.05s-13.42 5.22-15.04 13.05h30.08Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-11)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "parseable_inline_svg__clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.42 59.91c0-17.9 10.94-32.31 28.09-32.31 7.21 0 14.91 2.86 19.39 8.82v-7.58h16.28v62.14H496.9v-7.46c-4.35 5.97-12.18 8.7-19.39 8.7-17.15 0-28.09-14.42-28.09-32.31m47.1 0c0-9.7-6.21-16.9-14.79-16.9s-15.41 7.21-15.41 16.9 6.46 16.9 15.41 16.9 14.79-6.96 14.79-16.9Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-14)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "parseable_inline_svg__clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.64 83.52v7.46h-15.78V9.21h16.65v26.6c4.48-5.34 11.56-8.2 18.77-8.2 17.15 0 28.33 14.42 28.33 32.31s-10.94 32.31-28.09 32.31c-7.46 0-15.29-2.73-19.88-8.7Zm31.07-23.61c0-9.7-6.46-16.9-15.41-16.9s-14.79 7.21-14.79 16.9 6.34 16.9 14.79 16.9c8.95 0 15.41-7.08 15.41-16.9Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-17)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "parseable_inline_svg__clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.42 9.21h16.65v81.77h-16.65V9.21Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-20)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "parseable_inline_svg__clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.71 61.82c0-17.9 13.92-32.31 32.19-32.31 16.9 0 30.2 14.42 30.2 32.06 0 2.98-.37 5.97-.37 5.97h-45.11c1.99 8.57 9.07 12.68 17.27 12.68 5.97 0 12.18-1.74 16.78-4.85l6.21 11.93c-6.96 4.6-15.04 6.83-23.12 6.83-18.15 0-34.05-11.81-34.05-32.31Zm46.73-5.34c-1.24-7.83-7.46-13.05-15.04-13.05s-13.42 5.22-15.04 13.05h30.08Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-23)"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".parseable_inline_svg__cls-5{fill:#545beb}.parseable_inline_svg__cls-18{fill:url(#parseable_inline_svg__linear-gradient-2)}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#parseable_inline_svg__clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.22.1h603.59v144.64H108.22z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient)"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.02 59.91c0-17.9 10.94-32.31 28.09-32.31 7.21 0 14.91 2.86 19.39 8.82v-7.58h16.28v62.14H244.5v-7.46c-4.35 5.97-12.18 8.7-19.39 8.7-17.15 0-28.09-14.42-28.09-32.31Zm47.1 0c0-9.7-6.21-16.9-14.79-16.9s-15.41 7.21-15.41 16.9 6.46 16.9 15.41 16.9 14.79-6.96 14.79-16.9Z",
    className: "parseable_inline_svg__cls-18"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#parseable_inline_svg__clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.68 0h603.59v144.64H108.68z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-3)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.45 28.84h16.4v11.93c1.74-5.09 8.08-13.17 21.75-13.17v18.15c-14.42 0-21.5 6.59-21.5 21.38v23.86h-16.65V28.84Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#parseable_inline_svg__clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.68 0h603.59v144.64H108.68z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-6)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m317.44 83.77 5.97-12.8c4.23 3.23 10.07 6.59 19.39 6.59 3.85 0 10.19-1.49 10.19-5.22s-5.34-4.6-10.69-6.09c-12.3-3.23-22.37-7.33-22.37-19.26 0-12.68 12.43-19.39 24.11-19.39 10.19 0 16.65 2.49 23.12 6.21l-5.59 12.43c-6.09-2.98-11.81-4.35-17.27-4.35-3.85 0-7.46 1.74-7.46 4.35 0 3.48 5.22 4.6 10.94 5.84 10.56 2.49 22.12 7.08 22.12 19.76 0 15.29-15.54 20.38-27.09 20.38-13.3 0-21.87-5.22-25.35-8.45Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#parseable_inline_svg__clippath-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.68 0h603.59v144.64H108.68z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-9)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.97 59.91c0-17.9 13.92-32.31 32.19-32.31 16.9 0 30.2 14.42 30.2 32.06 0 2.98-.37 5.97-.37 5.97h-45.11c1.99 8.57 9.07 12.68 17.28 12.68 5.96 0 12.18-1.74 16.78-4.85l6.21 11.93c-6.96 4.6-15.04 6.83-23.11 6.83-18.15 0-34.05-11.81-34.05-32.31Zm46.73-5.34c-1.24-7.83-7.46-13.05-15.04-13.05s-13.42 5.22-15.04 13.05h30.08Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#parseable_inline_svg__clippath-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.68 0h603.59v144.64H108.68z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-12)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.42 59.91c0-17.9 10.94-32.31 28.09-32.31 7.21 0 14.91 2.86 19.39 8.82v-7.58h16.28v62.14H496.9v-7.46c-4.35 5.97-12.18 8.7-19.39 8.7-17.15 0-28.09-14.42-28.09-32.31m47.1 0c0-9.7-6.21-16.9-14.79-16.9s-15.41 7.21-15.41 16.9 6.46 16.9 15.41 16.9 14.79-6.96 14.79-16.9Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#parseable_inline_svg__clippath-5)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.68 0h603.59v144.64H108.68z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-15)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M541.64 83.52v7.46h-15.78V9.21h16.65v26.6c4.48-5.34 11.56-8.2 18.77-8.2 17.15 0 28.33 14.42 28.33 32.31s-10.94 32.31-28.09 32.31c-7.46 0-15.29-2.73-19.88-8.7Zm31.07-23.61c0-9.7-6.46-16.9-15.41-16.9s-14.79 7.21-14.79 16.9 6.34 16.9 14.79 16.9c8.95 0 15.41-7.08 15.41-16.9Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#parseable_inline_svg__clippath-6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.68 0h603.59v144.64H108.68z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-18)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M600.42 9.21h16.65v81.77h-16.65V9.21Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#parseable_inline_svg__clippath-7)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.68 0h603.59v144.64H108.68z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-21)"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m88.95 67.95-40.6 40.6c-1.79 1.79-.38 4.86 2.14 4.66 10.76-.84 21.29-5.37 29.52-13.6s12.76-18.76 13.6-29.52c.2-2.53-2.87-3.94-4.66-2.14ZM89.29 46.38l-.07-.15c-2.4-5.06-9.03-6.29-12.98-2.33L24.31 95.83c-3.96 3.96-2.73 10.58 2.33 12.98l.15.07c3.04 1.43 6.65.74 9.03-1.63l51.84-51.84c2.37-2.37 3.06-5.99 1.63-9.03ZM45.27 24.27c1.79-1.79.38-4.86-2.14-4.66-10.76.84-21.29 5.37-29.52 13.6C5.38 41.43.85 51.96 0 62.72c-.2 2.53 2.87 3.94 4.66 2.14l40.61-40.59ZM11.92 71.44 5.96 77.4a8.043 8.043 0 0 0-1.59 9.12l.06.14c2.37 5.03 9.02 6.18 12.95 2.25l6-6a8.106 8.106 0 0 0 0-11.47 8.106 8.106 0 0 0-11.47 0Z",
    className: "parseable_inline_svg__cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m42.19 64.11 27.13-27.13c3.93-3.93 2.78-10.57-2.25-12.95l-.14-.06a8.026 8.026 0 0 0-9.12 1.59L30.72 52.65a8.106 8.106 0 0 0 0 11.47 8.106 8.106 0 0 0 11.47 0Z",
    style: {
      fill: "#fc466b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.71 61.82c0-17.9 13.92-32.31 32.19-32.31 16.9 0 30.2 14.42 30.2 32.06 0 2.98-.37 5.97-.37 5.97h-45.11c1.99 8.57 9.07 12.68 17.27 12.68 5.97 0 12.18-1.74 16.78-4.85l6.21 11.93c-6.96 4.6-15.04 6.83-23.12 6.83-18.15 0-34.05-11.81-34.05-32.31Zm46.73-5.34c-1.24-7.83-7.46-13.05-15.04-13.05s-13.42 5.22-15.04 13.05h30.08Z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#parseable_inline_svg__clippath-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.36.05h603.59v144.64H118.36z",
    style: {
      fill: "url(#parseable_inline_svg__linear-gradient-24)"
    }
  })));
};
export default SvgParseableinline;